
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"19","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 8.328a1.595 1.595 0 00-.071-.324v-.108a1.284 1.284 0 00-.226-.336L11.578.36a1.269 1.269 0 00-.332-.228.376.376 0 00-.107 0A1.038 1.038 0 0010.747 0H3.563c-.945 0-1.851.38-2.52 1.054A3.62 3.62 0 000 3.6v16.8c0 .955.375 1.87 1.043 2.546A3.544 3.544 0 003.563 24h11.874c.945 0 1.851-.38 2.52-1.054A3.62 3.62 0 0019 20.4v-12-.072zm-7.125-4.236L14.951 7.2h-1.889c-.314 0-.617-.126-.84-.351A1.206 1.206 0 0111.876 6V4.092zm4.75 16.308c0 .318-.125.623-.348.849a1.181 1.181 0 01-.84.351H3.563c-.315 0-.617-.126-.84-.352a1.206 1.206 0 01-.348-.848V3.6c0-.318.125-.623.348-.849.223-.225.525-.351.84-.351H9.5V6c0 .955.375 1.87 1.043 2.546a3.544 3.544 0 002.52 1.054h3.562v10.8zm-4.75-6h-1.188v-1.2c0-.318-.125-.623-.347-.848a1.181 1.181 0 00-1.68 0c-.222.224-.348.53-.348.848v1.2H7.125c-.315 0-.617.126-.84.351a1.206 1.206 0 000 1.697c.223.226.525.352.84.352h1.188V18c0 .318.125.623.347.849a1.181 1.181 0 001.68 0c.222-.226.348-.53.348-.849v-1.2h1.187c.315 0 .617-.126.84-.352a1.206 1.206 0 000-1.697 1.181 1.181 0 00-.84-.351z","fill":"#40916C"}})])
          )
        }
      }
    